var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIngredient1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.71768 2.80703L2.98682 1.53789C5.03643 -0.511719 8.35518 -0.511719 10.4013 1.53438L11.6704 2.80703C12.2048 3.34141 11.8251 4.25547 11.0692 4.25547H2.31885C1.56299 4.25547 1.18331 3.34141 1.71768 2.80703Z",
    fill: "url(#paint0_linear_1_2844)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.71768 2.80703L2.98682 1.53789C5.03643 -0.511719 8.35518 -0.511719 10.4013 1.53438L11.6704 2.80703C12.2048 3.34141 11.8251 4.25547 11.0692 4.25547H2.31885C1.56299 4.25547 1.18331 3.34141 1.71768 2.80703Z",
    fill: "url(#paint1_linear_1_2844)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.71768 2.80703L2.98682 1.53789C5.03643 -0.511719 8.35518 -0.511719 10.4013 1.53438L11.6704 2.80703C12.2048 3.34141 11.8251 4.25547 11.0692 4.25547H2.31885C1.56299 4.25547 1.18331 3.34141 1.71768 2.80703Z",
    fill: "url(#paint2_linear_1_2844)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.6657 0.78905C5.73172 0.78905 5.78524 0.735534 5.78524 0.669519C5.78524 0.603504 5.73172 0.549988 5.6657 0.549988C5.59969 0.549988 5.54617 0.603504 5.54617 0.669519C5.54617 0.735534 5.59969 0.78905 5.6657 0.78905Z",
    fill: "url(#paint3_linear_1_2844)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.42312 2.21642C5.48914 2.21642 5.54265 2.1629 5.54265 2.09689C5.54265 2.03087 5.48914 1.97736 5.42312 1.97736C5.35711 1.97736 5.30359 2.03087 5.30359 2.09689C5.30359 2.1629 5.35711 2.21642 5.42312 2.21642Z",
    fill: "url(#paint4_linear_1_2844)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M4.70947 1.08434C4.77548 1.08434 4.829 1.03082 4.829 0.964807C4.829 0.898792 4.77548 0.845276 4.70947 0.845276C4.64345 0.845276 4.58994 0.898792 4.58994 0.964807C4.58994 1.03082 4.64345 1.08434 4.70947 1.08434Z",
    fill: "url(#paint5_linear_1_2844)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M8.11608 2.53984C8.1821 2.53984 8.23561 2.48633 8.23561 2.42031C8.23561 2.3543 8.1821 2.30078 8.11608 2.30078C8.05007 2.30078 7.99655 2.3543 7.99655 2.42031C7.99655 2.48633 8.05007 2.53984 8.11608 2.53984Z",
    fill: "url(#paint6_linear_1_2844)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M7.42001 0.841785C7.48602 0.841785 7.53954 0.788269 7.53954 0.722253C7.53954 0.656238 7.48602 0.602722 7.42001 0.602722C7.35399 0.602722 7.30048 0.656238 7.30048 0.722253C7.30048 0.788269 7.35399 0.841785 7.42001 0.841785Z",
    fill: "url(#paint7_linear_1_2844)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M7.42001 2.33947C7.48602 2.33947 7.53954 2.28595 7.53954 2.21993C7.53954 2.15392 7.48602 2.1004 7.42001 2.1004C7.35399 2.1004 7.30048 2.15392 7.30048 2.21993C7.30048 2.28595 7.35399 2.33947 7.42001 2.33947Z",
    fill: "url(#paint8_linear_1_2844)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M9.18133 1.20391C9.24735 1.20391 9.30086 1.15039 9.30086 1.08438C9.30086 1.01836 9.24735 0.964844 9.18133 0.964844C9.11531 0.964844 9.0618 1.01836 9.0618 1.08438C9.0618 1.15039 9.11531 1.20391 9.18133 1.20391Z",
    fill: "url(#paint9_linear_1_2844)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M6.45321 1.5941C6.51923 1.5941 6.57274 1.54059 6.57274 1.47457C6.57274 1.40856 6.51923 1.35504 6.45321 1.35504C6.3872 1.35504 6.33368 1.40856 6.33368 1.47457C6.33368 1.54059 6.3872 1.5941 6.45321 1.5941Z",
    fill: "url(#paint10_linear_1_2844)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M9.76141 2.01952C9.82742 2.01952 9.88094 1.966 9.88094 1.89999C9.88094 1.83397 9.82742 1.78046 9.76141 1.78046C9.69539 1.78046 9.64188 1.83397 9.64188 1.89999C9.64188 1.966 9.69539 2.01952 9.76141 2.01952Z",
    fill: "url(#paint11_linear_1_2844)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M3.50359 2.09685C3.56961 2.09685 3.62313 2.04333 3.62313 1.97732C3.62313 1.9113 3.56961 1.85779 3.50359 1.85779C3.43758 1.85779 3.38406 1.9113 3.38406 1.97732C3.38406 2.04333 3.43758 2.09685 3.50359 2.09685Z",
    fill: "url(#paint12_linear_1_2844)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0626 8.95587L12.1802 7.08907C11.8602 6.41407 11.7899 5.58438 11.9903 4.83204C12.1309 4.30469 11.6669 3.80899 11.129 3.92149L8.3411 4.49102C7.25126 4.71251 6.12977 4.71251 5.03993 4.49102L2.25204 3.92149C1.72118 3.81251 1.25712 4.30469 1.39774 4.83204C1.59813 5.58438 1.52782 6.41055 1.2079 7.08907L0.328993 8.95587C-0.247569 10.1793 -0.0506942 11.7719 0.796571 12.693C0.989931 12.9004 1.23251 13.0164 1.48212 13.0164H11.913C12.1626 13.0164 12.4052 12.9004 12.5985 12.693C13.4423 11.7684 13.6391 10.1793 13.0626 8.95587Z",
    fill: "url(#paint13_linear_1_2844)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9466 8.71329H0.441498L1.2079 7.08907C1.40829 6.66719 1.51025 6.18555 1.51025 5.7004C1.51025 5.4086 1.47509 5.1168 1.39775 4.83204C1.25712 4.30469 1.72119 3.80899 2.25908 3.92149L5.04697 4.49102C6.13681 4.71251 7.25829 4.71251 8.34814 4.49102L11.136 3.92149C11.6071 3.82657 12.022 4.19219 12.022 4.64219C12.022 4.70548 12.0149 4.76876 11.9974 4.83555C11.797 5.5879 11.8673 6.41407 12.1872 7.09259L12.9466 8.71329Z",
    fill: "url(#paint14_linear_1_2844)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1802 7.08907C11.8602 6.41407 11.7899 5.58438 11.9903 4.83204C12.1309 4.30469 11.6669 3.80899 11.129 3.92149L8.34109 4.49102C7.65203 4.63165 6.94891 4.68438 6.2493 4.64571V13.0164H11.9059C12.1555 13.0164 12.3981 12.9004 12.5915 12.693C13.4388 11.7719 13.6356 10.1793 13.0591 8.95587L12.1802 7.08907Z",
    fill: "url(#paint15_linear_1_2844)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3895 10.559C13.4036 10.0105 13.2981 9.45155 13.0626 8.95233L12.3981 7.54608H10.3766L13.3895 10.559Z",
    fill: "url(#paint16_linear_1_2844)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1485 2.75429C12.1485 2.75077 12.1485 2.75077 12.1485 2.74726C12.1485 2.4414 11.8497 2.22343 11.5614 2.3289C10.2677 2.79999 8.56259 3.08827 6.6958 3.08827C4.829 3.08827 3.12392 2.79999 1.83017 2.32538C1.54189 2.21991 1.23955 2.43788 1.24306 2.74374V2.75077C1.24306 3.14101 1.15517 3.50311 1.004 3.82304C0.74736 4.35741 0.982906 4.99374 1.53134 5.21874C2.85673 5.76015 4.68134 6.09413 6.69931 6.09413C8.71728 6.09413 10.5419 5.76015 11.8673 5.21874C12.4157 4.99374 12.6513 4.35741 12.3946 3.82304C12.2364 3.50663 12.1485 3.14101 12.1485 2.75429Z",
    fill: "url(#paint17_linear_1_2844)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1485 2.75429C12.1485 2.75077 12.1485 2.75077 12.1485 2.74726C12.1485 2.4414 11.8497 2.22343 11.5614 2.3289C10.2677 2.79999 8.56259 3.08827 6.6958 3.08827C4.829 3.08827 3.12392 2.79999 1.83017 2.32538C1.54189 2.21991 1.23955 2.43788 1.24306 2.74374V2.75077C1.24306 3.14101 1.15517 3.50311 1.004 3.82304C0.74736 4.35741 0.982906 4.99374 1.53134 5.21874C2.85673 5.76015 4.68134 6.09413 6.69931 6.09413C8.71728 6.09413 10.5419 5.76015 11.8673 5.21874C12.4157 4.99374 12.6513 4.35741 12.3946 3.82304C12.2364 3.50663 12.1485 3.14101 12.1485 2.75429Z",
    fill: "url(#paint18_linear_1_2844)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1485 2.75429C12.1485 2.75077 12.1485 2.75077 12.1485 2.74726C12.1485 2.4414 11.8497 2.22343 11.5614 2.3289C10.2677 2.79999 8.56259 3.08827 6.6958 3.08827C4.829 3.08827 3.12392 2.79999 1.83017 2.32538C1.54189 2.21991 1.23955 2.43788 1.24306 2.74374V2.75077C1.24306 3.14101 1.15517 3.50311 1.004 3.82304C0.74736 4.35741 0.982906 4.99374 1.53134 5.21874C2.85673 5.76015 4.68134 6.09413 6.69931 6.09413C8.71728 6.09413 10.5419 5.76015 11.8673 5.21874C12.4157 4.99374 12.6513 4.35741 12.3946 3.82304C12.2364 3.50663 12.1485 3.14101 12.1485 2.75429Z",
    fill: "url(#paint19_linear_1_2844)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M0.905548 4.14999C2.39617 4.75116 4.44227 5.12382 6.69578 5.12382C8.95281 5.12382 10.9954 4.75116 12.486 4.14999C12.472 4.04101 12.4403 3.93202 12.3911 3.82655C12.2364 3.51015 12.152 3.14452 12.152 2.75429C12.152 2.75077 12.152 2.75077 12.152 2.74726C12.152 2.4414 11.8532 2.22343 11.5649 2.3289C10.2712 2.79999 8.56609 3.08827 6.6993 3.08827C4.8325 3.08827 3.12391 2.79999 1.83016 2.32538C1.54188 2.21991 1.23953 2.43788 1.24305 2.74374V2.75077C1.24305 3.14101 1.15516 3.50311 1.00399 3.82304C0.947736 3.92851 0.919611 4.03749 0.905548 4.14999Z",
    fill: "url(#paint20_linear_1_2844)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1485 2.74726C12.1485 2.4414 11.8497 2.22343 11.5614 2.3289C10.2677 2.79999 8.56259 3.08827 6.69579 3.08827C4.82899 3.08827 3.12391 2.79999 1.83016 2.32538C1.54188 2.21991 1.23954 2.43788 1.24305 2.74374V2.75077C1.24305 2.94061 1.22196 3.11991 1.18329 3.29569C2.64579 3.83358 4.57938 4.16054 6.69579 4.16054C8.81571 4.16054 10.7458 3.83358 12.2083 3.29569C12.1696 3.11991 12.1485 2.94061 12.1485 2.75077V2.74726Z",
    fill: "url(#paint21_linear_1_2844)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1485 2.75431C12.1485 2.7508 12.1485 2.7508 12.1485 2.74728C12.1485 2.44142 11.8497 2.22345 11.5614 2.32892C10.5454 2.69806 9.27627 2.9547 7.87354 3.04962V6.059C9.42041 5.95705 10.8021 5.6547 11.8638 5.22228C12.4122 4.99728 12.6478 4.36095 12.3911 3.82658C12.2364 3.50665 12.1485 3.14103 12.1485 2.75431Z",
    fill: "url(#paint22_linear_1_2844)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M0.328993 8.95583C-0.247569 10.1793 -0.0506942 11.7719 0.796571 12.6929C0.989931 12.9004 1.23251 13.0164 1.48212 13.0164H11.913C12.1626 13.0164 12.4052 12.9004 12.5985 12.6929C13.4458 11.7719 13.6427 10.1793 13.0661 8.95583L12.9501 8.71326H0.441493L0.328993 8.95583Z",
    fill: "url(#paint23_linear_1_2844)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2255 13.0129L7.90867 10.6961H7.4657V13.0129H10.2255Z",
    fill: "url(#paint24_linear_1_2844)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_2844",
    x1: 4.38031,
    y1: -0.484156,
    x2: 6.88649,
    y2: 3.72623,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5FBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2414,
    stopColor: "#F0F8FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4916,
    stopColor: "#E4F2FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7457,
    stopColor: "#CFE8FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B3DAFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_2844",
    x1: 6.93423,
    y1: 2.42471,
    x2: 6.63347,
    y2: 3.65275,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8AC9FE",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1291,
    stopColor: "#89C8FD",
    stopOpacity: 0.019
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2629,
    stopColor: "#88C6FB",
    stopOpacity: 0.075
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3989,
    stopColor: "#87C4F8",
    stopOpacity: 0.168
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5365,
    stopColor: "#85C0F4",
    stopOpacity: 0.298
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6753,
    stopColor: "#83BBEF",
    stopOpacity: 0.466
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8151,
    stopColor: "#7FB5E9",
    stopOpacity: 0.672
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9532,
    stopColor: "#7CAEE1",
    stopOpacity: 0.911
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7BACDF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1_2844",
    x1: 6.29197,
    y1: 1.69873,
    x2: 6.74309,
    y2: 3.60343,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8AC9FE",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1291,
    stopColor: "#89C8FD",
    stopOpacity: 0.019
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2629,
    stopColor: "#88C6FB",
    stopOpacity: 0.075
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3989,
    stopColor: "#87C4F8",
    stopOpacity: 0.168
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5365,
    stopColor: "#85C0F4",
    stopOpacity: 0.298
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6753,
    stopColor: "#83BBEF",
    stopOpacity: 0.466
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8151,
    stopColor: "#7FB5E9",
    stopOpacity: 0.672
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9532,
    stopColor: "#7CAEE1",
    stopOpacity: 0.911
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7BACDF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1_2844",
    x1: 3.30704,
    y1: -1.69196,
    x2: 6.44023,
    y2: 1.44124,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8AC9FE",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1291,
    stopColor: "#89C8FD",
    stopOpacity: 0.019
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2629,
    stopColor: "#88C6FB",
    stopOpacity: 0.075
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3989,
    stopColor: "#87C4F8",
    stopOpacity: 0.168
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5365,
    stopColor: "#85C0F4",
    stopOpacity: 0.298
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6753,
    stopColor: "#83BBEF",
    stopOpacity: 0.466
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8151,
    stopColor: "#7FB5E9",
    stopOpacity: 0.672
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9532,
    stopColor: "#7CAEE1",
    stopOpacity: 0.911
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7BACDF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1_2844",
    x1: 3.06477,
    y1: -0.261674,
    x2: 6.19796,
    y2: 2.87152,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8AC9FE",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1291,
    stopColor: "#89C8FD",
    stopOpacity: 0.019
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2629,
    stopColor: "#88C6FB",
    stopOpacity: 0.075
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3989,
    stopColor: "#87C4F8",
    stopOpacity: 0.168
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5365,
    stopColor: "#85C0F4",
    stopOpacity: 0.298
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6753,
    stopColor: "#83BBEF",
    stopOpacity: 0.466
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8151,
    stopColor: "#7FB5E9",
    stopOpacity: 0.672
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9532,
    stopColor: "#7CAEE1",
    stopOpacity: 0.911
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7BACDF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1_2844",
    x1: 2.35052,
    y1: -1.39513,
    x2: 5.48372,
    y2: 1.73806,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8AC9FE",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1291,
    stopColor: "#89C8FD",
    stopOpacity: 0.019
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2629,
    stopColor: "#88C6FB",
    stopOpacity: 0.075
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3989,
    stopColor: "#87C4F8",
    stopOpacity: 0.168
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5365,
    stopColor: "#85C0F4",
    stopOpacity: 0.298
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6753,
    stopColor: "#83BBEF",
    stopOpacity: 0.466
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8151,
    stopColor: "#7FB5E9",
    stopOpacity: 0.672
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9532,
    stopColor: "#7CAEE1",
    stopOpacity: 0.911
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7BACDF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1_2844",
    x1: 5.75664,
    y1: 0.0609404,
    x2: 8.88984,
    y2: 3.19414,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8AC9FE",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1291,
    stopColor: "#89C8FD",
    stopOpacity: 0.019
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2629,
    stopColor: "#88C6FB",
    stopOpacity: 0.075
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3989,
    stopColor: "#87C4F8",
    stopOpacity: 0.168
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5365,
    stopColor: "#85C0F4",
    stopOpacity: 0.298
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6753,
    stopColor: "#83BBEF",
    stopOpacity: 0.466
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8151,
    stopColor: "#7FB5E9",
    stopOpacity: 0.672
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9532,
    stopColor: "#7CAEE1",
    stopOpacity: 0.911
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7BACDF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1_2844",
    x1: 5.05895,
    y1: -1.63736,
    x2: 8.19214,
    y2: 1.49583,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8AC9FE",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1291,
    stopColor: "#89C8FD",
    stopOpacity: 0.019
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2629,
    stopColor: "#88C6FB",
    stopOpacity: 0.075
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3989,
    stopColor: "#87C4F8",
    stopOpacity: 0.168
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5365,
    stopColor: "#85C0F4",
    stopOpacity: 0.298
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6753,
    stopColor: "#83BBEF",
    stopOpacity: 0.466
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8151,
    stopColor: "#7FB5E9",
    stopOpacity: 0.672
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9532,
    stopColor: "#7CAEE1",
    stopOpacity: 0.911
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7BACDF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1_2844",
    x1: 5.05895,
    y1: -0.14056,
    x2: 8.19214,
    y2: 2.99264,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8AC9FE",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1291,
    stopColor: "#89C8FD",
    stopOpacity: 0.019
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2629,
    stopColor: "#88C6FB",
    stopOpacity: 0.075
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3989,
    stopColor: "#87C4F8",
    stopOpacity: 0.168
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5365,
    stopColor: "#85C0F4",
    stopOpacity: 0.298
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6753,
    stopColor: "#83BBEF",
    stopOpacity: 0.466
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8151,
    stopColor: "#7FB5E9",
    stopOpacity: 0.672
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9532,
    stopColor: "#7CAEE1",
    stopOpacity: 0.911
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7BACDF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1_2844",
    x1: 6.82012,
    y1: -1.27398,
    x2: 9.95332,
    y2: 1.85923,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8AC9FE",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1291,
    stopColor: "#89C8FD",
    stopOpacity: 0.019
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2629,
    stopColor: "#88C6FB",
    stopOpacity: 0.075
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3989,
    stopColor: "#87C4F8",
    stopOpacity: 0.168
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5365,
    stopColor: "#85C0F4",
    stopOpacity: 0.298
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6753,
    stopColor: "#83BBEF",
    stopOpacity: 0.466
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8151,
    stopColor: "#7FB5E9",
    stopOpacity: 0.672
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9532,
    stopColor: "#7CAEE1",
    stopOpacity: 0.911
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7BACDF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1_2844",
    x1: 4.09408,
    y1: -0.885537,
    x2: 7.22725,
    y2: 2.24766,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8AC9FE",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1291,
    stopColor: "#89C8FD",
    stopOpacity: 0.019
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2629,
    stopColor: "#88C6FB",
    stopOpacity: 0.075
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3989,
    stopColor: "#87C4F8",
    stopOpacity: 0.168
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5365,
    stopColor: "#85C0F4",
    stopOpacity: 0.298
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6753,
    stopColor: "#83BBEF",
    stopOpacity: 0.466
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8151,
    stopColor: "#7FB5E9",
    stopOpacity: 0.672
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9532,
    stopColor: "#7CAEE1",
    stopOpacity: 0.911
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7BACDF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_1_2844",
    x1: 7.40224,
    y1: -0.458293,
    x2: 10.5354,
    y2: 2.67491,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8AC9FE",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1291,
    stopColor: "#89C8FD",
    stopOpacity: 0.019
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2629,
    stopColor: "#88C6FB",
    stopOpacity: 0.075
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3989,
    stopColor: "#87C4F8",
    stopOpacity: 0.168
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5365,
    stopColor: "#85C0F4",
    stopOpacity: 0.298
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6753,
    stopColor: "#83BBEF",
    stopOpacity: 0.466
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8151,
    stopColor: "#7FB5E9",
    stopOpacity: 0.672
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9532,
    stopColor: "#7CAEE1",
    stopOpacity: 0.911
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7BACDF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_1_2844",
    x1: 1.14363,
    y1: -0.382859,
    x2: 4.27682,
    y2: 2.75033,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8AC9FE",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1291,
    stopColor: "#89C8FD",
    stopOpacity: 0.019
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2629,
    stopColor: "#88C6FB",
    stopOpacity: 0.075
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3989,
    stopColor: "#87C4F8",
    stopOpacity: 0.168
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5365,
    stopColor: "#85C0F4",
    stopOpacity: 0.298
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6753,
    stopColor: "#83BBEF",
    stopOpacity: 0.466
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8151,
    stopColor: "#7FB5E9",
    stopOpacity: 0.672
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9532,
    stopColor: "#7CAEE1",
    stopOpacity: 0.911
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7BACDF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_1_2844",
    x1: 1.05525,
    y1: 6.83159,
    x2: 11.3267,
    y2: 9.97589,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6A96C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3561,
    stopColor: "#F1A468"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7245,
    stopColor: "#E5985F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D88A55"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_1_2844",
    x1: 6.69513,
    y1: 7.43648,
    x2: 6.69513,
    y2: 5.07824,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB5D4C",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1413,
    stopColor: "#BB5D4C",
    stopOpacity: 0.022
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2877,
    stopColor: "#BB5D4C",
    stopOpacity: 0.089
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4366,
    stopColor: "#BB5D4C",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5872,
    stopColor: "#BB5D4C",
    stopOpacity: 0.355
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.739,
    stopColor: "#BB5D4C",
    stopOpacity: 0.556
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8898,
    stopColor: "#BB5D4C",
    stopOpacity: 0.797
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BB5D4C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_1_2844",
    x1: 10.6439,
    y1: 8.49775,
    x2: 12.9235,
    y2: 7.9999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB5D4C",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1413,
    stopColor: "#BB5D4C",
    stopOpacity: 0.022
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2877,
    stopColor: "#BB5D4C",
    stopOpacity: 0.089
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4366,
    stopColor: "#BB5D4C",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5872,
    stopColor: "#BB5D4C",
    stopOpacity: 0.355
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.739,
    stopColor: "#BB5D4C",
    stopOpacity: 0.556
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8898,
    stopColor: "#BB5D4C",
    stopOpacity: 0.797
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BB5D4C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_1_2844",
    x1: 11.8153,
    y1: 9.62322,
    x2: 12.0351,
    y2: 7.82543,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB5D4C",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1413,
    stopColor: "#BB5D4C",
    stopOpacity: 0.022
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2877,
    stopColor: "#BB5D4C",
    stopOpacity: 0.089
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4366,
    stopColor: "#BB5D4C",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5872,
    stopColor: "#BB5D4C",
    stopOpacity: 0.355
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.739,
    stopColor: "#BB5D4C",
    stopOpacity: 0.556
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8898,
    stopColor: "#BB5D4C",
    stopOpacity: 0.797
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BB5D4C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_1_2844",
    x1: 6.69513,
    y1: 3.0213,
    x2: 6.69513,
    y2: 5.9952,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6A96C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3561,
    stopColor: "#F1A468"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7245,
    stopColor: "#E5985F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D88A55"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_1_2844",
    x1: 6.83593,
    y1: 4.95792,
    x2: 7.15037,
    y2: 6.47765,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB5D4C",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1413,
    stopColor: "#BB5D4C",
    stopOpacity: 0.022
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2877,
    stopColor: "#BB5D4C",
    stopOpacity: 0.089
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4366,
    stopColor: "#BB5D4C",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5872,
    stopColor: "#BB5D4C",
    stopOpacity: 0.355
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.739,
    stopColor: "#BB5D4C",
    stopOpacity: 0.556
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8898,
    stopColor: "#BB5D4C",
    stopOpacity: 0.797
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BB5D4C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_1_2844",
    x1: 6.69007,
    y1: 4.38023,
    x2: 6.58527,
    y2: 6.51136,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB5D4C",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1413,
    stopColor: "#BB5D4C",
    stopOpacity: 0.022
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2877,
    stopColor: "#BB5D4C",
    stopOpacity: 0.089
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4366,
    stopColor: "#BB5D4C",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5872,
    stopColor: "#BB5D4C",
    stopOpacity: 0.355
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.739,
    stopColor: "#BB5D4C",
    stopOpacity: 0.556
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8898,
    stopColor: "#BB5D4C",
    stopOpacity: 0.797
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BB5D4C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_1_2844",
    x1: 6.81173,
    y1: 4.17302,
    x2: 7.7201,
    y2: 6.61859,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB5D4C",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1413,
    stopColor: "#BB5D4C",
    stopOpacity: 0.022
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2877,
    stopColor: "#BB5D4C",
    stopOpacity: 0.089
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4366,
    stopColor: "#BB5D4C",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5872,
    stopColor: "#BB5D4C",
    stopOpacity: 0.355
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.739,
    stopColor: "#BB5D4C",
    stopOpacity: 0.556
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8898,
    stopColor: "#BB5D4C",
    stopOpacity: 0.797
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BB5D4C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_1_2844",
    x1: 6.65388,
    y1: 3.28265,
    x2: 5.97259,
    y2: 6.06013,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB5D4C",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1413,
    stopColor: "#BB5D4C",
    stopOpacity: 0.022
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2877,
    stopColor: "#BB5D4C",
    stopOpacity: 0.089
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4366,
    stopColor: "#BB5D4C",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5872,
    stopColor: "#BB5D4C",
    stopOpacity: 0.355
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.739,
    stopColor: "#BB5D4C",
    stopOpacity: 0.556
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8898,
    stopColor: "#BB5D4C",
    stopOpacity: 0.797
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BB5D4C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_1_2844",
    x1: 11.0329,
    y1: 4.12199,
    x2: 12.5876,
    y2: 4.05214,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB5D4C",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1413,
    stopColor: "#BB5D4C",
    stopOpacity: 0.022
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2877,
    stopColor: "#BB5D4C",
    stopOpacity: 0.089
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4366,
    stopColor: "#BB5D4C",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5872,
    stopColor: "#BB5D4C",
    stopOpacity: 0.355
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.739,
    stopColor: "#BB5D4C",
    stopOpacity: 0.556
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8898,
    stopColor: "#BB5D4C",
    stopOpacity: 0.797
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BB5D4C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_1_2844",
    x1: 6.69512,
    y1: 11.1572,
    x2: 6.69512,
    y2: 13.2017,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB5D4C",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1413,
    stopColor: "#BB5D4C",
    stopOpacity: 0.022
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2877,
    stopColor: "#BB5D4C",
    stopOpacity: 0.089
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4366,
    stopColor: "#BB5D4C",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5872,
    stopColor: "#BB5D4C",
    stopOpacity: 0.355
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.739,
    stopColor: "#BB5D4C",
    stopOpacity: 0.556
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8898,
    stopColor: "#BB5D4C",
    stopOpacity: 0.797
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BB5D4C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_1_2844",
    x1: 9.06854,
    y1: 11.8452,
    x2: 7.9491,
    y2: 11.8953,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB5D4C",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1413,
    stopColor: "#BB5D4C",
    stopOpacity: 0.022
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2877,
    stopColor: "#BB5D4C",
    stopOpacity: 0.089
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4366,
    stopColor: "#BB5D4C",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5872,
    stopColor: "#BB5D4C",
    stopOpacity: 0.355
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.739,
    stopColor: "#BB5D4C",
    stopOpacity: 0.556
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8898,
    stopColor: "#BB5D4C",
    stopOpacity: 0.797
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BB5D4C"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIngredient1);
export default __webpack_public_path__ + "static/media/ingredient_1.eb20a6c250c12d6355a91d694ca82cf2.svg";
export { ForwardRef as ReactComponent };